module.exports = "<router-outlet><app-spinner></app-spinner></router-outlet>\n\n"